import { Link } from "react-router-dom";
import { ArrowUpRight, BrickWall, Building2, Hammer, Layers, Paintbrush, Sofa } from "lucide-react";
import { Kicker, Reveal, SectionHead, prefillService } from "./Reveal";
import { SERVICES } from "../data/content";

const ICONS = { Building2, Layers, Sofa, Paintbrush, BrickWall, Hammer };

export const ServicesOverview = () => (
  <section id="leistungen" className="bg-surface border-y border-line py-24 md:py-32" data-testid="services-overview-section">
    <div className="container-x">
      <SectionHead
        kicker="Leistungen"
        testId="services-overview-title"
        title={<>Sechs Felder. <span className="font-fraktur text-golddark">Ein Standard.</span></>}
        text="Fassade, Innenraum, Putz und Renovierung – präzise ausgeführt, ehrlich kalkuliert. Alle Details auf unserer Leistungsseite."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.id} delay={i * 0.05} className="h-full">
              <Link
                to="/leistungen"
                data-testid={`service-card-${s.id}`}
                className="card-arch group flex flex-col p-8 h-full"
              >
                <div className="flex items-start justify-between">
                  <Icon size={26} className="text-golddark" strokeWidth={1.5} />
                  <span className="font-mono text-xs font-bold text-muted/60">{s.num}</span>
                </div>
                <h3 className="font-display text-xl font-semibold tracking-tight text-ink mt-6">{s.title}</h3>
                <p className="text-muted text-sm leading-relaxed mt-3">{s.tags.join("  ·  ")}</p>
                <span className="link-cta !text-xs mt-auto pt-6 inline-flex items-center gap-2">
                  Mehr erfahren <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export const Services = () => (
  <section id="leistungen-detail" className="bg-white py-24 md:py-32" data-testid="services-section">
    <div className="container-x">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12 md:mb-16">
        <div>
          <Reveal>
            <Kicker>Leistungen im Detail</Kicker>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 data-testid="services-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] mt-4 text-ink">
              Sechs Felder. <span className="font-fraktur text-golddark">Ein Standard.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.16} className="max-w-md">
          <p className="text-muted leading-relaxed">
            Wir gestalten, schützen und veredeln Oberflächen – von Griesemert aus für die Stadt Olpe, Wenden und
            das gesamte Südsauerland. Wählen Sie Ihr Vorhaben; die Anfrage ist bereits vorbereitet.
          </p>
        </Reveal>
      </div>
      <div className="border-t border-line">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.04}>
            <article
              className="group grid lg:grid-cols-12 gap-8 lg:gap-14 items-center py-12 md:py-16 border-b border-line"
              data-testid={`service-panel-${s.id}`}
            >
              <div className="lg:col-span-2">
                <span className="font-mono font-bold text-4xl md:text-6xl leading-none text-gold/40 transition-colors duration-500 group-hover:text-gold">
                  {s.num}
                </span>
              </div>
              <div className="lg:col-span-6">
                <h3 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-ink">{s.title}</h3>
                <p className="text-muted leading-relaxed mt-4 max-w-xl">{s.text}</p>
                <p className="mt-5 font-mono text-[11px] tracking-[0.18em] uppercase font-semibold text-muted">{s.tags.join("  ·  ")}</p>
                <button
                  onClick={() => prefillService(s.prefill)}
                  data-testid={`service-cta-${s.id}`}
                  className="link-cta mt-7"
                >
                  {s.title} anfragen <ArrowUpRight size={15} />
                </button>
              </div>
              <div className={`lg:col-span-4 ${i % 2 ? "lg:order-first" : ""}`}>
                <div className="overflow-hidden border border-line aspect-[4/3]">
                  <img
                    src={s.image}
                    alt={`${s.title} – Leistungen von Manfred Berglar, Malermeister aus Olpe-Griesemert`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
